import { formatDate } from "@angular/common";
import { Component, Input, SimpleChanges } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { OrderFilter, OrderTradeWidget } from "src/app/models/order";
import { ApiService } from "src/app/services/api.service";
import {
  MarketWatchDetailService,
  StockDetail,
} from "src/app/services/market-watch-detail.service";
import { Account } from "../profile/user-profile-details/client-data";

@Component({
  selector: "user-trades-summary",
  templateUrl: "./user-trades-summary.component.html",
  styleUrls: ["./user-trades-summary.component.scss"],
})
export class UserTradesSummaryComponent {
  isTradesLoading: boolean;
  today = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Africa/Cairo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(new Date()); 
  tradeRequest: OrderFilter = {} as OrderFilter;
  allMarketNames: StockDetail[];
  @Input() acc;
  selectedAccount: any;
  allAvailableFunds: any[];
  trades: OrderTradeWidget[] = [];
  accType: any;
  accList: Account[];

  constructor(
    private _service: ApiService,
    public translate: TranslateService,
    private _marketDetail: MarketWatchDetailService
  ) {}

  ngOnInit(){
    if (this._marketDetail.marketNames)
    this.allMarketNames = this._marketDetail.marketNames.getValue();
  this._marketDetail.namesSubject.subscribe((res) => {
    this.allMarketNames = res as StockDetail[];
  this.updateStockDetail()

  });
  }
fetchAvailableFunds(): void {
  this._service.GetMutualFundList().subscribe((res) => {
    this.allAvailableFunds = res as any[];
    this.updateStockDetail(); // re-run after funds are loaded
  });
}
  ngOnChanges(changes: SimpleChanges): void {
    this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
    this.accType = this.accList.filter(x=>x.relationCode == this.acc)[0]?.accountType
    // this.accType = this.accList.filter(x=>x.relationCode == this.accList[0].relationCode)[0]?.accountType
    if (this.acc && this.acc != 0) {
      this.selectedAccount = this.acc;
      this.tradeRequest.fromDate = this.tradeRequest.toDate = this.today;
      this.tradeRequest.relationCode = this.selectedAccount;
      this.fetchTradesSummary(this.tradeRequest);
          if (this.accType == 3) {
      this.fetchAvailableFunds();
    }
    }
    if (this._marketDetail.marketNames)
      this.allMarketNames = this._marketDetail.marketNames.getValue();
    this._marketDetail.namesSubject.subscribe((res) => {
      this.allMarketNames = res as StockDetail[];
    });
  }

  fetchTradesSummary(request: OrderFilter) {
    this.isTradesLoading = true;
    this._service.fetchWidgetfilteredTransactions(request).subscribe((res) => {
      this.isTradesLoading = false;
      if (res) this.trades = res as OrderTradeWidget[];
      else this.trades = [];
      this.updateStockDetail();
    });
  }

updateStockDetail() {
  if (this.accType == 3) {
    if (this.trades && this.allAvailableFunds) {
      this.trades.forEach((item) => {
        const fund = this.allAvailableFunds.find(
          (x) => x["SymbolCode"] === item.SymbolCode
        );
        if (fund) {
          item.ArbName = fund["FundNameA"];
          item.EngName = fund["FundNameE"];
        } else {
          // Fallback if no match found
          item.ArbName = item.SymbolCode;
          item.EngName = item.SymbolCode;
        }
      });
    }
    return;
  }

  if (this.trades && this.allMarketNames) {
    this.trades.forEach((item) => {
      const tradeDetail = this.allMarketNames.find(
        (x) => x["SYMBOL_CODE"] === item.SymbolCode
      );
      if (tradeDetail) {
        item.ArbName = tradeDetail["arb_shortname"];
        item.EngName = tradeDetail["eng_shortname"];
      }
    });
  }
}
  getColor(item) {
    switch (item) {
      case 1:
        return {
          background: "#2cac6c",
          color: "white",
          width: "3vw",
          lineHeight: "1.25",
          fontSize: "75%",
        };
      case 2:
        return {
          background: "#dc3545",
          color: "white",
          width: "3vw",
          lineHeight: "1.25",
          fontSize: "75%",
        };
      default: {
        return {
          background: "lightgray",
          color: "black",
        };
      }
    }
  }
}
